import {Movement} from "../utils/ratingConstants";

export class ComponentRating {
    constructor(public rating: string | null,
                public comments: string | null,
                public ratingPrevious: string | null,
                public movement: Movement) {
    }
}
